export default __webpack_public_path__ + "3ea2f1c9d604d2d96f9f6eb22e762076.png";